import React, { useEffect, useState } from "react";
import Sidebar from "../profile-sidebar/profileSidebar";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { tourAssignmentService } from "../../services/tourAssignmentService";
import { toast } from "react-toastify";
import moment from "moment";

const TourAssign = () => {
  const [tourAssignments, setTourAssignments] = useState([]); // State để lưu danh sách TourAssignment
  const [loading, setLoading] = useState(false); // State để hiển thị loading
  const [page, setPage] = useState(1);
  const [pageSize] = useState(2);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTourAssignments = async () => {
      setLoading(true);
      try {
        const data = await tourAssignmentService.getPendingTourAssignments(
          page,
          pageSize
        );
        setTourAssignments(data.data.items || []); // Lấy danh sách từ Items
        setTotal(data.data.total || 0); // Lấy tổng số từ Total
      } catch (error) {
        console.error("Lỗi tải danh sách tour cần assign: ", error);
        toast.error("Không thể tải danh sách tour cần assign.");
      } finally {
        setLoading(false);
      }
    };

    fetchTourAssignments();
  }, [page, pageSize]);

  // Xử lý nút Assign
  const handleAssign = (tourAssignmentId) => {
    // Điều hướng đến trang assign với tourAssignmentId
    navigate(`/assign-tour-guide/${tourAssignmentId}`);
  };

  // Xử lý nút View
  const handleView = (tourAssignmentId) => {
    // Điều hướng đến trang xem chi tiết với tourAssignmentId
    navigate(`/view-tour-guide/${tourAssignmentId}`);
  };
  const totalPages = Math.ceil(total / pageSize);

  return (
    <div>
      {/* <!-- Page Wrapper --> */}
      <div className="content">
        <div className="container">
          <div className="row">
            {/* <!-- Sidebar --> */}
            <Sidebar page="tour-assign" />
            {/* <!-- /Sidebar --> */}

            <div className="col-xl-9 col-lg-8">
              <div className="card shadow-none mb-0">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h6>Danh sách Tour đang chờ phân công</h6>
                </div>
                <div className="card-body">
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "100%" }}
                    >
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                    </div>
                  ) : tourAssignments && tourAssignments.length === 0 ? (
                    <p>Không có tour nào đang chờ phân công.</p>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th>Tên Tour</th>
                              <th>Ngày bắt đầu</th>
                              <th>Ngày kết thúc</th>
                              <th>Trạng thái </th>
                              <th>Hành động</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tourAssignments && tourAssignments.length > 0
                              ? tourAssignments.map((tour) => (
                                  <tr key={tour.tourAssignmentId}>
                                    <td>
                                      {tour.tour ? tour.tour.tourName : "N/A"}
                                    </td>
                                    <td>
                                      {tour
                                        ? moment(tour.startDate).format(
                                            "DD-MM-YYYY"
                                          )
                                        : "N/A"}
                                    </td>
                                    <td>
                                      {tour
                                        ? moment(tour.endDate).format(
                                            "DD-MM-YYYY"
                                          )
                                        : "N/A"}
                                    </td>
                                    <td>
                                      {tour.status === 3 ? (
                                        <span className="text-warning">
                                          Pending
                                        </span>
                                      ) : (
                                        <span className="text-info">
                                          Waiting
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      {tour.status === 3 ? (
                                        <button
                                          className="btn btn-primary btn-sm"
                                          onClick={() =>
                                            handleAssign(tour.tourAssignmentId)
                                          }
                                        >
                                          Assign
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-info btn-sm"
                                          onClick={() =>
                                            handleView(tour.tourAssignmentId)
                                          }
                                        >
                                          View
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              : ""}
                          </tbody>
                        </table>
                      </div>
                      {/* Phân trang */}
                      <div className="d-flex justify-content-between mt-3">
                        <button
                          className="btn btn-secondary"
                          disabled={page === 1}
                          onClick={() => setPage(page - 1)}
                        >
                          Trang trước
                        </button>
                        <span>
                          Trang {page} / {totalPages}
                        </span>
                        <button
                          className="btn btn-secondary"
                          disabled={page === totalPages}
                          onClick={() => setPage(page + 1)}
                        >
                          Trang sau
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourAssign;
